import React, { useEffect, useState } from "react";import { useSearchParams, useNavigate } from "react-router-dom";

import axiosInstance from "../axios/axios";
import SuccessMessage from "./SuccessMessage";
import ErrorMessage from "./ErrorMessage";

const SetupInterview = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const id = searchParams.get("id");
  const org_id = localStorage.getItem("role_specific_id");
  const [date, setDate] = useState("");
  const [alt_date_1, setAlt_date_1] = useState("");
  const [alt_date_2, setAlt_date_2] = useState("");
  const [meetLink, setMeetLink] = useState("");
  const [application, setApplication] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const fetchViewedApplication = async () => {
      try {
        const res = await axiosInstance.put(`ReviewApplicationByOrg/${id}`, {
          org_id: org_id, // Ensure this is sent as a JSON object
        });
        const response = await axiosInstance.get("all_users");
        const foundOrg = response.data.users.find(
          (o) => o.organization_id === parseInt(org_id)
        );
        console.log(foundOrg.organization.interview_link);
        setMeetLink(foundOrg.organization.interview_link);
        const foundUser = response.data.users.find(
          (u) => u.user_id === parseInt(res.data.application.user_id)
        );
        console.log(response);
        console.log(foundUser);

        console.log(res.data.application);
        setApplication(res.data.application || []);
      } catch (error) {
        console.error("Error fetching applications:", error);
      }
    };
    fetchViewedApplication();
  }, [id, org_id]);

  const handleSetupInterview = async (e) => {
    e.preventDefault();

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    };

    const data = {
      application_id: application.id,
      job_id: application.job_id,
      user_id: application.user_id,
      org_id,
      date: formatDate(date),
      meet_link: meetLink,
      alt_date_1: formatDate(alt_date_1),
      alt_date_2: formatDate(alt_date_2),
    };
    console.log(data);

    try {
      const res = await axiosInstance.post("interviews/schedule", data);
      console.log(res);
      setSuccess("Interview scheduled successfully.");
      setTimeout(() => {
        navigate("/dashboard/interviews");
      }, 2000);      
    } catch (error) {
      setError("Failed to schedule interview. Please try again later.");
      setTimeout(() => {
        setError(null);
      }, 3000);
      console.log(error);
    }
  };

  return (
    <div className="mt-6 p-4 flex items-center justify-center flex-col gap-4 ">
      <div className="top-bar">
        <span>Setup Interview </span>
      </div>
      {success && <SuccessMessage message={success} />}
      {error && <ErrorMessage message={error} />}
      <form
        className="flex flex-wrap flex-col gap-3 mt-6 md:w-[60%]"
        onSubmit={handleSetupInterview}
      >
        <div className="flex flex-col gap-2">
          <label htmlFor="" className="text-[#344054] text-sm">
            Choose Preferred Date and time
          </label>
          <input
            type="datetime-local"
            className="custom-form"
            required
            id=""
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>
        <div className="flex flex-col gap-2">
          <label htmlFor="" className="text-[#344054] text-sm">
            Choose Alternative Date and time 1
          </label>
          <input
            type="datetime-local"
            className="custom-form"
            id=""
            required
            value={alt_date_1}
            onChange={(e) => setAlt_date_1(e.target.value)}
          />{" "}
        </div>
        <div className="flex flex-col gap-2">
          <label htmlFor="" className="text-[#344054] text-sm">
            Choose Alternative Date and time 2
          </label>
          <input
            type="datetime-local"
            required
            className="custom-form"
            id=""
            value={alt_date_2}
            onChange={(e) => setAlt_date_2(e.target.value)}
          />{" "}
        </div>
        <div className="flex flex-col gap-2">
          <label htmlFor="" className="text-[#344054] text-sm">
            Google Meet Link
          </label>
          <input
            type="url"
            className="custom-form"
            id=""
            value={meetLink}
            disabled
          />
        </div>
        <button type="submit" className="btn btn-success">
          Finish
        </button>
      </form>
    </div>
  );
};

export default SetupInterview;
